import { useRentalManagerUserPropertyMultiplexWebApiHandler_archive } from '@zg-rentals/ts-rental-manager-api-client-react-query';

import { DEFAULT_ARCHIVE_INVALIDATES } from '../../../constants/InvalidateConstants';

import type { MutateOptions } from '@zg-rentals/react-query5';
import type { RentalManagerUserPropertyMultiplexWebApiHandler_archive_Args } from '@zg-rentals/ts-rental-manager-api-client-react-query';

type ArchiveMultiplexPropertyOptions = Parameters<typeof useRentalManagerUserPropertyMultiplexWebApiHandler_archive>[0];

type ArchiveMultiplexPropertyMutateOptions = MutateOptions<
  void,
  unknown,
  RentalManagerUserPropertyMultiplexWebApiHandler_archive_Args
>;

/**
 * Archives all units in a multiplex property via /api/web/v1/users/properties/multiplex/archive.
 *
 * Merges default `meta.invalidates` (plus any `meta.invalidates` you pass) and sets `meta.context`
 * for logging unless overridden.
 */
export const useArchiveMultiplexProperty = (options: ArchiveMultiplexPropertyOptions = {}) => {
  const { meta: metaOverrides, ...restOptions } = options;

  const mutation = useRentalManagerUserPropertyMultiplexWebApiHandler_archive({
    ...restOptions,
    meta: {
      ...metaOverrides,
      invalidates: [...DEFAULT_ARCHIVE_INVALIDATES, ...(metaOverrides?.invalidates ?? [])],
      context: {
        api: 'archive',
        details: 'useArchiveMultiplexProperty',
        ...metaOverrides?.context,
      },
    },
  });

  const archiveMultiplexProperty = (groupId: string, mutateOptions?: ArchiveMultiplexPropertyMutateOptions) =>
    mutation.mutate({ postData: { groupId } }, mutateOptions);

  return { ...mutation, archiveMultiplexProperty };
};
